import styles from "./styles.module.scss";
import React, { useEffect } from "react";
import useCollapse from "react-collapsed";
import { Link } from "react-router-dom";

function Collapsible() {
    const { getCollapseProps, getToggleProps, isExpanded } = useCollapse({ duration: 1000 });
    return (
        <div className={styles.collapsible}>
            <div className={styles.header} {...getToggleProps()}>
                <p>{isExpanded ? '-' : '+'}</p>
                <text>Développement web : Nos domaines d'intervention</text>
            </div>
            <div {...getCollapseProps()}>
                <div className={styles.content}>
                    Forts d’une expertise notable en développement d’applications Web,
                    nos professionnels prennent appui sur une analyse approfondie de vos b
                    esoins afin de vous livrer un produit final personnalisé et de qualité.
                </div>
            </div>
        </div>
    );
}
function Collapsible2() {
    const { getCollapseProps, getToggleProps, isExpanded } = useCollapse({ duration: 1000 });
    return (
        <div className={styles.collapsible}>
            <div className={styles.header} {...getToggleProps()}>
                <p>{isExpanded ? '-' : '+'}</p>
                <text>Développement web : notre méthodologie</text>
            </div>
            <div {...getCollapseProps()}>
                <div className={styles.content}>
                    Développer une application Web requiert la mobilisation de compétences pluridisciplinaires pointues, de la rigueur et un souci du détail. 
                    <br />
                    Chez OrgaExpert, nous suivons une méthodologie minutieuse et éprouvée pour vous garantir une intervention efficace au plus près de votre besoin.
                    <br /><br />
                    Notre méthodologie se découpe en 5 phases majeures : <br />
                    - Etude des besoins <br />
                    - Design <br />
                    - Intégration et développement <br />
                    - Test et déploiement <br />
                    - Suivi et entretien <br />
                </div>
            </div>
        </div>
    );
}


function Intro() {
    useEffect(() => {
        window.scrollTo(0, 1000)
    }, [])

    return (
        <>
            <section className={styles.container}>
                <div className={styles.title}>
                    <text>Développement web</text>
                    <p>pour la réussite de vos projets</p>
                </div>
                <div className={styles.bigbox}>

                    <div className={styles.service}>
                        <div className={styles.bigText}>Développement web</div>
                        <div className={styles.paragraph}>
                            La présence en ligne est un palier incontournable par lequel toute entreprise devrait passer si elle souhaite renforcer son image de marque.<br /><br />
                            Vous ne pouvez vous intéresser à l’identité numérique de votre entreprise sans penser un site web.<br />
                            Évidemment, un site web pour une entreprise est équivalent à une carte d’identité pour une personne.
                            Votre site web est, souvent, votre premier contact avec vos clients potentiels et là tout se met en jeu pour que votre client soit accroché ou non !<br /><br />
                            Nos experts accompagnent les professionnels en quête d’une meilleure accessibilité et d’une plus grande mobilité, au développement des sites et des applications
                            web du plus simple au plus complexe, en fonction de votre budget et de vos besoins.
                        </div>
                    </div>


                    <div className={styles.expandable}>
                        <Collapsible />
                        <Collapsible2 />
                    </div>

                </div>
                <div className={styles.title}>
                    <div className={styles.text2}>Autre services</div>
                </div>
                <div className={styles.bigbox2}>
                    <Link to="/services/developpementMobile">
                        <div className={styles.service1}>
                            <div className={styles.bigText}>Développement Mobile</div>
                            <img src="/icons/smartphone.png" alt="web dev" />
                        </div>
                    </Link>
                    <Link to="/services/e_commerce">
                        <div className={styles.service1}>
                            <div className={styles.bigText}>E-COMMERCE ET MARKETPLACES</div>
                            <img src="/icons/e-commerce.png" alt="web dev" />

                        </div>
                    </Link>
                    <Link to="/services/transformation_digital">
                        <div className={styles.service1}>
                            <div className={styles.bigText}>CONSEIL ET STRATÉGIE</div>
                            <img src="/icons/assist.png" alt="web dev" />

                        </div>
                    </Link>
                    <Link to="/services/erp">
                        <div className={styles.service1}>
                            <div className={styles.bigText}>INTÉGRATION ERP</div>
                            <img src="/icons/integration.png" alt="web dev" />

                        </div>
                    </Link>
                    <Link to="/services/seo">
                        <div className={styles.service1}>
                            <div className={styles.bigText}>SEO ET OPTIMISATION</div>
                            <img src="/icons/seo.png" alt="web dev" />
                        </div>
                    </Link>
                </div>
            </section>
        </>
    )
}

export default Intro;